<template>
  <div class="container help" id="help5_page">
      <div class="tab">
          <p>
            <a @click="type='mobile'" class="mobile" :class="{active:type=='mobile'}" href="javascript:;">移动端</a>
            <a @click="type='pc'" class="pc" :class="{active:type=='pc'}" href="javascript:;">PC端</a>
          </p>
      </div>
      <div class="content_img">
          <img v-show="type=='mobile'" src="../../assets/img/mobile_help5.png" />
          <img v-show="type=='pc'"  src="../../assets/img/pc_help5.png" />
      </div>
    <div>
    </div>
    <home :ishome=0 :hasNeigou="false"></home>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
import home from '../common/home.vue'
  export default {
    data() {
      return {
          type:'mobile'
      }
    },
    components: {
    home
  },
    computed: {
      ...mapGetters({}),

    },
    watch: {},
    created() {

    },
    methods: {},
    mounted() {

    }
  }
</script>
<style lang="scss" scoped>
$pole:375/10;
#help5_page{
    div.tab{
        left: 0; 
        top: 0;
        right: 0;
        position: fixed;
        background: #fff;
        height: 76rem/$pole;
        display: flex;
        align-items:center;
            justify-content:center;
        p{
            width: 242rem/$pole;
            height: 30rem/$pole;
            border-radius:15rem/$pole;
            box-shadow:0px 0px 13rem/$pole -3rem/$pole rgba(0,0,0,0.17);
            a{
                width: 49.9%;
                text-emphasis: center;
                color: #43BBFF;
                border-radius:15rem/$pole;
                float: left;
                 height: 30rem/$pole;
                 line-height: 30rem/$pole;
                 text-align: center;
                 font-size: 14rem/$pole;
                &.pc{
                    float: right;
                }
                &.active{
                    background: #43BBFF;
                    color: #fff;
                    font-size: 14rem/$pole;
                    box-shadow:0px 0px 15rem/$pole -3rem/$pole rgba(56,183,255,1);
                }
            }
        }
    }
    .content_img{
        padding-top:76rem/$pole ;
        img{
            height: auto;
        }
    }
    
}

</style>